<template>
    <div class="field-body">
        <el-divider content-position="left">字段选择</el-divider>
        <div class="field-choose">
            <el-drag-select v-model="chooseFields" multiple placeholder="请选择" style="width: 75%;border-radius: 20px;"
                @change='selectAll'>
                <template v-if="isGroup === true">
                    <el-option-group v-for="group in sourceOptions" :key="group.label" :label="group.label">
                        <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-option-group>
                </template>
                <template v-else-if="isGroup === false">
                    <el-option v-for="item in sourceOptions" :key="item.id" :label="item.label" :style="getStyle(item)"
                        :value="item.id"></el-option>
                </template>
            </el-drag-select>
        </div>
        <el-divider content-position="left">别名设置(不设置默认是字段名)</el-divider>
        <div class="field-main">
            <div class="field-item" v-for="(item,index) in allChooseFieldObjList" :key="index">
                <el-collapse>
                    <el-collapse-item :title="item.name" :name="index">
                        <el-input v-model.trim="item.alias" placeholder="设置字段别名" :key="timer"></el-input>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <el-divider content-position="left">虚拟字段</el-divider>
        <div class="field-fictitious">
            <el-tag :key="index" v-for="(item,index) in fictitiousList" closable :disable-transitions="false" @close="handleClose(item)">
                {{item.name}}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增字段</el-button>
        </div>
    </div>
</template>

<script>
    import {
        cloneDeep
    } from 'lodash';
    import ElDragSelect from '@/components/DragSelect';
    export default {
        components: {
            ElDragSelect
        },
        data () {
            return {
                oldOptions: [],
                chooseFields: [],
                myMap: new Map(),
                allChooseFieldIds: [],
                allChooseFieldObjList: [],
                fictitiousList: [],
                inputVisible: false,
                inputValue: '',
                timer: ''
            };
        },
        watch: {
            sourceOptions (val) {
                this.initMap();
                this.buildFieldItem();
            }
        },
        props: {
            isGroup: {
                type: Boolean,
                default: false
            },
            sourceOptions: { // 外部传入的下拉列表的结构数据
                type: Array
            },
            selectViewFields: { // 外部传入的下拉列表的结构数据
                type: Array,
                default: () => {
                    return [];
                }
            },
            selectedTableColumns: {
                type: Array
            }
        },
        created () {
            this.initFields();
        },
        methods: {
            initFields () {
                this.chooseFields = [];
                this.allChooseFieldObjList = [];
                this.allChooseFieldIds = [];
                this.fictitiousList = [];
                for (let i = 0; i < this.selectedTableColumns.length; i++) {
                    let cur = this.selectedTableColumns[i];
                    if (cur.fieldType && cur.fieldType === 'fictitious') {
                        cur.id = cur.prop;
                        this.fictitiousList.push(cur);
                    } else {
                        this.chooseFields.push(cur.prop);
                        this.allChooseFieldObjList.push(cur);
                        this.allChooseFieldIds.push(cur.prop);
                    }
                }
                // console.log(this.fictitiousList);
                // console.log(this.allChooseFieldObjList);
                this.timer = new Date().getTime();
                this.myMap = new Map();
            },
            getSelectFields () {
                let selectFields = cloneDeep(this.chooseFields);
                if (selectFields.includes('ALL_SELECT')) {
                    selectFields.splice(0, 1); // 排除全选选项
                }
                return selectFields.join(',');
            },
            getSelectViewFields () {
                if (this.chooseFields.includes('ALL_SELECT')) {
                    this.chooseFields.splice(0, 1); // 排除全选选项
                }
                let selectFieldArr = [];
                this.chooseFields.forEach((field) => {
                    if (this.myMap.has(field)) {
                        selectFieldArr.push(this.myMap.get(field));
                    }
                });
                for (let i = 0; i < this.fictitiousList.length; i++) {
                    let cur = this.fictitiousList[i];
                    selectFieldArr.push(cur);
                }
                return selectFieldArr;
            },
            initMap () { // 设置字段的k/v结构
                if (this.isGroup) { // 分组情况
                    this.sourceOptions.forEach((item) => {
                        item.options.forEach((child) => {
                            this.myMap.set(child.id, child);
                        });
                    });
                }
            },
            selectAll (val) {
                this.allChooseFieldIds = cloneDeep(val);
                const allValues = [];
                // 保留所有值
                for (const item of this.sourceOptions) {
                    allValues.push(item.id);
                }
                // 用来储存上一次的值，可以进行对比
                const oldVal = this.oldOptions.length === 1 ? this.oldOptions[0] : [];
                // 若是全部选择
                if (val.includes('ALL_SELECT')) {
                    this.chooseFields = allValues;
                }
                // 取消全部选中 上次有 当前没有 表示取消全选
                if (oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                    this.chooseFields = [];
                }
                // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
                // 新老数据都有全部选中
                if (oldVal.includes('ALL_SELECT') && val.includes('ALL_SELECT')) {
                    const index = val.indexOf('ALL_SELECT');
                    val.splice(index, 1); // 排除全选选项
                    this.chooseFields = val;
                }
                // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
                if (!oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                    if (!this.isGroup && val.length === allValues.length - 1) {
                        this.chooseFields = ['ALL_SELECT'].concat(val);
                    }
                }
                // 储存当前最后的结果 作为下次的老数据
                this.oldOptions[0] = this.chooseFields;
                this.buildFieldItem();
            },
            buildFieldItem () {
                let allField = [];
                for (let i = 0; i < this.sourceOptions.length; i++) {
                    let cur = this.sourceOptions[i];
                    let options = cur.options;
                    for (let j = 0; j < options.length; j++) {
                        let fieldItem = options[j];
                        let obj = this.allChooseFieldObjList.find(item => item.prop === fieldItem.id);
                        if (obj && obj.alias !== obj.name) {
                            fieldItem.alias = obj.alias;
                        }
                        allField.push(fieldItem);
                    }
                }
                this.allChooseFieldObjList = [];
                for (let j = 0; j < this.allChooseFieldIds.length; j++) {
                    let json = this.allChooseFieldIds[j];
                    let obj = allField.find(item => item.id === json);
                    if (obj) {
                        let originalFieldType = obj.fieldType;
                        obj.fieldType = 'form';
                        obj.originalFieldType = originalFieldType;
                        this.allChooseFieldObjList.push(obj);
                    }
                }
            },
            getStyle (item) {
                let single = {
                    'color': '#333'
                };
                if (item.id === 'appCreatedByName' || item.id === 'appCreatedByDate' || item.id ===
                    'processInstanceName' || item.id === 'createdByName' || item.id === 'createdDate') {
                    single.color = '#999';
                }
                return single;
            },
            handleClose (tag) {
                for (let i = 0; i < this.fictitiousList.length; i++) {
                    let cur = this.fictitiousList[i];
                    if (cur.id == tag.id) {
                        this.fictitiousList.splice(i, 1);
                    }
                }
            },
            showInput () {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm () {
                let inputValue = this.inputValue;
                if (inputValue) {
                    let obj = {name: inputValue, fieldType: 'fictitious', id: this.generateUUID(), type: 'text'};
                    this.fictitiousList.push(obj);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            }
        }
    };
</script>
<style lang="less">
    .field-body {
        min-height: 40vh;
        max-height: 80vh;

        .field-main {
            margin-top: 10px;
            max-height: 30vh;
            overflow: auto;
        }

        .el-divider__text {
            color: indianred;
        }

        .field-fictitious {
            .el-tag+.el-tag {
                margin-left: 10px;
            }

            .button-new-tag {
                margin-left: 10px;
                height: 32px;
                line-height: 30px;
                padding-top: 0;
                padding-bottom: 0;
            }

            .input-new-tag {
                width: 90px;
                margin-left: 10px;
                vertical-align: bottom;
            }

            // display: flex;
            // .field-fictitious-btn{
            //      width: 24px;
            //      height: 24px;
            //      line-height: 24px;
            //      border: 1px solid #F2F2F2;
            //      text-align: center;
            //      border-radius: 4px;
            //      cursor: pointer;
            //      margin-left: 10px;
            // }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SelectMultiple/SelectMultipleReport.vue